import { normalizeProductCategorySlug } from './productCategories';

export const appRoutes = {
  home: '/',
  login: '/login',
  about: '/about',
  contact: '/contact',
  products: '/product',
  legacyProducts: '/products',
  productBase: '/product/item',
  news: '/news',
  gallery: '/gallery',
  commercialTool: '/interactive-map',
  legacyCommercialTool: '/commercial-tool',
  admin: '/admin',
  adminMapContent: '/admin/interactive-map',
  adminNews: '/admin/news',
  adminNewsNew: '/admin/news/new',
  adminUsers: '/admin/users',
  adminNewsEdit: (id: string) => `/admin/news/${encodeURIComponent(id)}/edit`,
  productById: (id: string) => `/product/item/${encodeURIComponent(id)}`,
  productBySlug: (slugOrId: string) => `/product/item/${encodeURIComponent(slugOrId)}`,
  productsByCategory: (category: string) => `/product/${normalizeProductCategorySlug(category)}`,
  productLine: (category: string, subCategory?: string) => {
    const basePath = `/product/${normalizeProductCategorySlug(category)}`;
    const safeSubCategory = subCategory?.trim();

    if (!safeSubCategory) {
      return basePath;
    }

    return `${basePath}?sub=${encodeURIComponent(safeSubCategory)}`;
  }
} as const;
